export default "__VITE_ASSET__Rj1ffPde__"